import * as React from "react";
import { ErrorType, TextBox } from "@genesys/ui-elements";
import styled from "styled-components";

const StyledTextBox = styled(TextBox)<{
  readonly height?: string;
  readonly width?: string;
}>`
  height: ${props => props.height || "28px"};
  width: ${props => props.width || "100px"};
  cursor: pointer;
  font-size: 13px;
  text-align: center;
  padding: 0;
  border-bottom: 1px solid transparent;
  display: inline-block;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export function CustomTab(props: {
  readonly value: string;
  readonly isReadOnly: boolean;
  readonly hasError: ErrorType;
  readonly height?: string;
  readonly width?: string;
  readonly onChange: (value: string) => void;
}) {
  const { value, isReadOnly, hasError, width, height, onChange } = props;

  React.useEffect(() => {
    setState({ value });
  }, [value]);

  const [state, setState] = React.useState({
    value
  });

  function internalOnChange(event: React.ChangeEvent<HTMLInputElement>) {
    const element = event.target as HTMLInputElement;

    setState({
      value: element.value
    });
  }

  return (
    <StyledTextBox
      value={state.value}
      onBlur={() => onChange(state.value)}
      onChange={event => internalOnChange(event)}
      height={height}
      width={width}
      hasError={hasError}
      errorMessage=""
      readOnly={isReadOnly}
    />
  );
}
